import React, { useState } from 'react';
import SpeechToText from '../components/webSpeechAPI/speechToText';

export const Secret = () => {

  return (
    <SpeechToText />
  );
};
